import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import AutoLoanAccountsView from './components/AutoLoanAccountsView';
import AutoRefinanceMarketplaceOffersView from './components/AutoRefinanceMarketplaceOffersView';

export const AutoRefinanceMarketplaceView = ({ ...props }) => {
  if (props.refinanceOffersLoading) {
    return <PageLoadingMask />;
  } else if (props.seeAutoRefinanceLoans) {
    return <AutoRefinanceMarketplaceOffersView {...props} />;
  } else if (!props.autoLoanAccounts || props.autoLoanAccounts.length < 1) {
    return <NoAutoLoanAccountsOpenView />;
  } else if (props.showAutoLoanList) {
    return <AutoLoanAccountsView {...props} />;
  } else {
    return <PageLoadingMask />;
  }
};

const NoAutoLoanAccountsOpenView = () => {
  return (
    <SectionContainer>
      <FlexContainer className="flex-column">
        <Row>
          <div className="text-center flex-rowWrap margTB48">
            <Label typeHeader={'h5'} className="H5 margB16">
              No Loans Found
            </Label>
            <Label className="header-description text-center">
              {'We were unable to find loans that match your credit profile.'}
            </Label>
          </div>
        </Row>
      </FlexContainer>
    </SectionContainer>
  );
};
